<div class="container mt-2 pb-4">
  <div class="row">
    <div class="video-container" #videoContainer>
      <video id="video-player" class="video-player video-js vjs-default-skin" controls playsinline webkit-playsinline
        poster="../../../../assets/images/video_banner_racing_roulette.png" (click)="onVideoClick()">
        <source [src]="rouletteVideoUrl" *ngIf="rouletteVideoUrl && !rouletteVideoUrl.includes('.m3u8')" />
        <source [src]="rouletteVideoUrl" *ngIf="rouletteVideoUrl?.includes('.m3u8')" type="application/x-mpegURL" />
      </video>
    </div>
  </div>

  <div class="row">
    <div class="betting-container">

      <!-- <div class="header"> -->
        <div class="event-box">
          <div class="currentEventName">{{CurrentEventName}}</div>
          <div class="event-right"> 
            <button 
              class="btn-result" 
              type="button"
              data-toggle="modal" 
              data-target="#raceresultModal"
            >
              <i class="bi bi-card-text"></i>
              {{'COMMON.RESULTS' | translate}}
            </button>
          </div>
        </div>
        <div class="event-box">

          <div class="event-left">Next Draw : <span class="timer">{{NextDrowEventCode}}</span></div>
          <div class="event-right"> <i class="bi bi-clock"></i><span class="timer">{{ timerDisplay }}</span></div>
        </div>
      <!-- </div> -->

      <div class="gradient-line"></div>

      <!-- Header: R1..R4 -->
      <div class="grid-header" *ngIf="specialMap">
        <button *ngFor="let col of ['R1', 'R2', 'R3', 'R4']" class="btn btn-header" [class.selected]="isSelected(col)"
          (click)="toggleSelection(col)">
          <span class="btn-label">{{ col }}</span>

          <ng-container *ngFor="let _ of [].constructor(getChipCount(col)); let i = index">
            <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
          </ng-container>
        </button>
      </div>

      <!-- Grid Layout -->
      <div class="grid-wrapper">
        <!-- Column 0 (Green) -->
        <div class="col-0">
          <button class="btn btn-green btn-tall" [class.selected]="isSelected(zeroNumber?.id)"
            (click)="toggleSelection(zeroNumber?.id)">
            <span class="btn-label">{{ zeroNumber?.label }}</span>

            <ng-container *ngFor="let _ of [].constructor(getChipCount(zeroNumber?.id))">
              <img src="../../../../../assets/images/casino-chip.png" alt="chip-icon" class="check-icon" />
            </ng-container>
          </button>
        </div>

        <!-- Main Grid -->
        <div class="main-grid">
          <!-- Row 1 -->
          <div class="grid-row">
            <button *ngFor="let num of row1" class="btn" [class.btn-red]="num.color === 'red'"
              [class.btn-black]="num.color === 'black'" [class.selected]="isSelected(num.id)"
              (click)="toggleSelection(num.id)">

              <span class="btn-label">{{ num.label }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount(num.id))">
                <img src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>

            </button>
          </div>

          <!-- Row 2 -->
          <div class="grid-row">
            <button *ngFor="let num of row2" class="btn" [class.btn-red]="num.color === 'red'"
              [class.btn-black]="num.color === 'black'" [class.selected]="isSelected(num.id)"
              (click)="toggleSelection(num.id)">

              <span class="btn-label">{{ num.label }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount(num.id))">
                <img src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>

            </button>
          </div>

          <!-- Row 3 -->
          <div class="grid-row">
            <button *ngFor="let num of row3" class="btn" [class.btn-red]="num.color === 'red'"
              [class.btn-black]="num.color === 'black'" [class.selected]="isSelected(num.id)"
              (click)="toggleSelection(num.id)">

              <span class="btn-label">{{ num.label }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount(num.id))">
                <img src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>

            </button>
          </div>

          <!-- Range Buttons: Low / High -->
          <div class="range-buttons-div" *ngIf="specialMap">
            <button class="btn btn-range" *ngIf="specialMap['Low']" [attr.data-id]="'low'"
              [class.selected]="isSelected('Low')" (click)="toggleSelection('Low')">

              <span class="btn-label">{{ specialMap['Low'].name }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount('Low')); let i = index">
                <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>
            </button>

            <button class="btn btn-range" *ngIf="specialMap['High']" [attr.data-id]="'high'"
              [class.selected]="isSelected('High')" (click)="toggleSelection('High')">
              <span class="btn-label">{{ specialMap['High'].name }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount('High')); let i = index">
                <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>
            </button>
          </div>

          <!-- Color/Parity Buttons -->
          <div class="color-buttons-div" *ngIf="specialMap">
            <button class="btn btn-parity" *ngIf="specialMap['Even']" [attr.data-id]="'even'"
              [class.selected]="isSelected('Even')" (click)="toggleSelection('Even')">

              <span class="btn-label">{{ specialMap['Even'].name }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount('Even')); let i = index">
                <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>
            </button>

            <button class="btn btn-red" *ngIf="specialMap['Red']" [attr.data-id]="'red'"
              [class.selected]="isSelected('Red')" (click)="toggleSelection('Red')">
              <span class="btn-label">{{ specialMap['Red'].name }}</span>
              <ng-container *ngFor="let _ of [].constructor(getChipCount('Red')); let i = index">
                <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>
            </button>

            <button class="btn btn-black" *ngIf="specialMap['Black']" [attr.data-id]="'black'"
              [class.selected]="isSelected('Black')" (click)="toggleSelection('Black')">
              <span class="btn-label">{{ specialMap['Black'].name }}</span>

              <ng-container *ngFor="let _ of [].constructor(getChipCount('Black')); let i = index">
                <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>
            </button>

            <button class="btn btn-parity" *ngIf="specialMap['Odd']" [attr.data-id]="'odd'"
              [class.selected]="isSelected('Odd')" (click)="toggleSelection('Odd')">
              <span class="btn-label">{{ specialMap['Odd'].name }}</span>
              <ng-container *ngFor="let _ of [].constructor(getChipCount('Odd')); let i = index">
                <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon" />
              </ng-container>
            </button>
          </div>
        </div>

        <!-- Column Buttons -->
        <div class="col-buttons-div" *ngIf="specialMap">
          <button class="btn btn-row-label" *ngIf="specialMap['C1']" [attr.data-id]="'C1'"
            [class.selected]="isSelected('C1')" (click)="toggleSelection('C1')">
            <span class="btn-label">{{ specialMap['C1'].name }}</span>
            <ng-container *ngFor="let _ of [].constructor(getChipCount('C1')); let i = index">
              <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon-c" />
            </ng-container>
          </button>

          <button class="btn btn-row-label" *ngIf="specialMap['C2']" [attr.data-id]="'C2'"
            [class.selected]="isSelected('C2')" (click)="toggleSelection('C2')">

            <span class="btn-label">{{ specialMap['C2'].name }}</span>
            <ng-container *ngFor="let _ of [].constructor(getChipCount('C2')); let i = index">
              <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon-c" />
            </ng-container>
          </button>

          <button class="btn btn-row-label" *ngIf="specialMap['C3']" [attr.data-id]="'C3'"
            [class.selected]="isSelected('C3')" (click)="toggleSelection('C3')">
            <span class="btn-label">{{ specialMap['C3'].name }}</span>
            <ng-container *ngFor="let _ of [].constructor(getChipCount('C3')); let i = index">
              <img alt="chip-icon" src="../../../../../assets/images/casino-chip.png" class="check-icon-c" />
            </ng-container>
          </button>
        </div>
      </div>

      <!-- Clear Button -->
      <div style="display:flex; justify-content:center; margin-top:12px;">
        <button class="btn-clear" (click)="clearAll()">
          Delete
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Result Modal -->
  <div class="modal fade" id="raceresultModal" data-backdrop="false" tabindex="100000" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="margin-left: 0px;margin-right: 0px;">
      <div class="modal-content" style="margin-top: 200px;margin-bottom: 100px;">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{'COMMON.RESULTS' | translate}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 35px;" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngFor="let item of kironResults" class="race-preview shadow p-0 mb-2">
            <div class="race-header bg-fill-secondary text-white">
              <div class="race-info">
                <div class="race-name text-uppercase">{{item.eventName}}</div>
                <div class="race-description text-uppercase">Game: {{item.eventCode}}</div>
              </div>
              <div class="race-extra">
                {{item.eventTimeUTC.substr(11,5)}}
                <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span>
              </div>
            </div>

            <div class="race-content">
              <table class="racing-table table-borderless table-striped">
                <thead>
                  <tr>
                    <th class="text-center">P</th>
                    <th>N</th>
                    <th class="text-left">Selection</th>
                    <th>Win</th>
                    <th>Place</th>
                  </tr>
                </thead>
                <tbody>

                  <tr class="won">
                    <td class="text-center">1</td>
                    <td>{{item.eventPositions[0].selectionNumber}}</td>
                    <td class="text-left">{{item.eventPositions[0].selectionName}}</td>
                    <td>{{item.eventPositions[0].winAmount}}</td>
                    <td>{{item.eventPositions[0].placeAmount}}</td>
                  </tr>

                  <tr class="">
                    <td class="text-center">2</td>
                    <td>{{item.eventPositions[1].selectionNumber}}</td>
                    <td class="text-left">{{item.eventPositions[1].selectionName}}</td>
                    <td>{{item.eventPositions[1].winAmount}}</td>
                    <td>{{item.eventPositions[1].placeAmount}}</td>
                  </tr>

                  <tr class="">
                    <td class="text-center">3</td>
                    <td>{{item.eventPositions[2].selectionNumber}}</td>
                    <td class="text-left">{{item.eventPositions[2].selectionName}}</td>
                    <td>{{item.eventPositions[2].winAmount}}</td>
                    <td>{{item.eventPositions[2].placeAmount}}</td>
                  </tr>

                </tbody>
              </table>
              <div class="result-box">
                <div class="result-row">
                  <span class="label"></span>
                  <span style="width: 30%;color: #555555c2;;">PAYS</span>
                  <span style="width: 30%;color: #555555c2;;">RESULT</span>
                </div>
                <div class="result-row">
                  <span class="label">Column</span>
                  <span class="value">{{item.krrPrices.winnerColumn}}</span>
                  <span class="value">{{item.krrWinnerColumn || '-'}}</span>
                </div>

                <div class="result-row">
                  <span class="label">Row</span>
                  <span class="value">{{item.krrPrices.winnerRow}}</span>
                  <span class="value">{{item.krrWinnerRow || '-'}}</span>
                </div>

                <div class="result-row">
                  <span class="label">Low / High</span>
                  <span class="value">{{item.krrPrices.winnerLowHigh}}</span>
                  <span class="value">{{item.krrWinnerLowHigh || '-'}}</span>
                </div>

                <div class="result-row">
                  <span class="label">Odd / Even</span>
                  <span class="value">{{item.krrPrices.winnerOddEven}}</span>
                  <span class="value">{{item.krrWinnerOddEven || '-'}}</span>
                </div>

                <div class="result-row">
                  <span class="label">Red / Black</span>
                  <span class="value">{{item.krrPrices.winnerRedBlack}}</span>
                  <span class="value">{{item.krrWinnerRedBlack || '-'}}</span>
                </div>
              </div>
            </div>

            <div class="race-footer">
              <div class="d-flex">
                <div class="d-flex flex-fill flex-column text-left">
                  <span class="t-faded t-small C_BK">Trifecta:</span>
                  <span class="t">{{item.tc}}</span>
                </div>
                <div class="d-flex flex-fill flex-column text-right">
                  <span class="t-faded t-small C_BK">Off Time:</span>
                  <span class="t">{{item.offTime}}</span>
                </div>
              </div>
            </div>


            <div class="race-footer">
              <div class="d-flex">
                <div class="d-flex flex-fill flex-column text-left">
                  <span class="t-faded t-small C_BK">Forecast:</span>
                  <span class="t">{{item.csf}}</span>
                </div>
                <div class="d-flex flex-fill flex-column text-right">
                  <span class="t-faded t-small C_BK">Quinella:</span>
                  <span class="t">{{item.qn}}</span>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div>